export const TickIcon = () => {
  return (
    <svg
      width="244"
      height="244"
      viewBox="0 0 244 244"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.226 222.34C79.3415 222.34 75.6131 220.747 72.8607 217.932L4.27617 147.375C-1.43351 141.503 -1.42375 131.985 4.29569 126.123C10.0151 120.252 19.2775 120.262 24.997 126.143L83.226 186.03L218.999 46.3981C224.709 40.5267 233.971 40.5167 239.701 46.3781C245.43 52.2395 245.43 61.758 239.72 67.6394L93.5913 217.932C90.8389 220.757 87.1105 222.34 83.226 222.34Z"
        fill="#0A874B"
      />
      <mask id="mask0_511_4998" maskUnits="userSpaceOnUse" x="0" y="41" width="244" height="182">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M83.226 222.34C79.3415 222.34 75.6131 220.747 72.8607 217.932L4.27617 147.375C-1.43351 141.503 -1.42375 131.985 4.29569 126.123C10.0151 120.252 19.2775 120.262 24.997 126.143L83.226 186.03L218.999 46.3981C224.709 40.5267 233.971 40.5167 239.701 46.3781C245.43 52.2395 245.43 61.758 239.72 67.6394L93.5913 217.932C90.8389 220.757 87.1105 222.34 83.226 222.34Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_511_4998)"></g>
    </svg>
  );
};
